import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { MarketingLayout } from '../../layouts/MarketingLayout';

const faqs = [
  {
    q: 'What is Keskedo?',
    o: 'Keskedo is a unified ecosystem that gives you a single, biometric identity for dozens of apps — plus secure data vaults, reputation, and community governance.',
  },
  {
    q: 'How does Keskedo identity work?',
    o: 'We use WebAuthn passkeys, which means your identity is bound to the device you already trust. No passwords, no shared secrets.',
  },
  {
    q: 'Is Keskedo free?',
    o: 'The core identity, data, and governance layer is free for individuals. Apps and developers may charge for value-added features built on top.',
  },
  {
    q: 'Who owns my data?',
    o: 'You do. Data lives in your encrypted vaults; apps request scoped access that you can grant or revoke at any time.',
  },
  {
    q: 'Can I use Keskedo with my existing apps?',
    o: 'Yes. We provide SDKs for web, iOS, and Android, plus a typed REST API for backend integrations.',
  },
  {
    q: 'How do I close my account?',
    o: 'You can close your account from Settings → Account → Close Account. We will export your data on request before deletion.',
  },
];

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <MarketingLayout
      title="Frequently asked questions"
      subtitle="The questions we hear most often. Need something else? Our team is one click away on the Contact page."
    >
      <div className="space-y-3">
        {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(isOpen ? null : i)}
                className="w-full text-left px-6 py-5 flex items-center justify-between gap-6"
              >
                <span className="font-bold text-slate-900">{faq.q}</span>
                <ChevronDown
                  size={18}
                  className={`flex-shrink-0 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                />
              </button>
              {isOpen && (
                <div className="px-6 pb-5 text-sm text-slate-600 leading-relaxed">{faq.o}</div>
              )}
            </div>
          );
        })}
      </div>
    </MarketingLayout>
  );
};
